import React from "react";
import cls from "./styles.module.scss";

interface GoalHeroStripesProps {
  variant?: "page" | "modal";
}

export const GoalHeroStripes = ({ variant = "page" }: GoalHeroStripesProps) => (
  <>
    <span
      className={[
        cls.stripe,
        cls.stripeLeft,
        variant === "modal" ? cls.stripeModal : "",
      ].join(" ")}
    />
    <span
      className={[
        cls.stripe,
        cls.stripeRight,
        variant === "modal" ? cls.stripeModal : "",
      ].join(" ")}
    />
  </>
);
